
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line'
    },
    {
      name: 'ISO',
      description: 'International Organization for Standardization',
      icon: 'ri-award-line'
    },
    {
      name: 'NFPA',
      description: 'National Fire Protection Association Standards',
      icon: 'ri-fire-line'
    },
    {
      name: 'BS',
      description: 'British Standards Compliance',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section className="bg-red-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Compliance &amp; Approvals</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            All FlameGuardQA fire safety products are certified and conform to international standards, 
            ensuring reliability and safety for your fire protection systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {certifications.map((cert, index) => (
            <div key={index} className="text-center bg-white p-6 rounded-lg shadow-sm">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${cert.icon} text-2xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{cert.name}</h3>
              <p className="text-sm text-gray-600">{cert.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-white p-8 rounded-lg shadow-sm max-w-4xl mx-auto">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Quality Assurance</h3>
            <p className="text-gray-600 leading-relaxed">
              FlameGuardQA maintains the highest quality standards through rigorous testing and certification processes. 
              Our products undergo comprehensive quality control checks and are regularly audited to ensure continued 
              compliance with QCDD, NFPA, UL, and BS standards for fire safety equipment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
